
















import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';
import { getQueryVariable } from '../common/common';
import ReportHeader from '../components/ReportHeader.vue';
import ReportFooter from '../components/ReportFooter.vue';
import CheckInfoOneToOne from '../components/onetoone/CheckInfoOneToOne.vue';
import ComparativeLiteratureInfo from '../components/onetoone/ComparativeLiteratureInfo.vue';
import CheckResultOneToOne from '../components/onetoone/CheckResultOneToOne.vue';
import SimilarListOneToOne from '../components/onetoone/SimilarListOneToOne.vue';
import ExplainOneToOne from '../components/onetoone/ExplainOneToOne.vue';

export default Vue.extend({
  name: 'OneToOne',
  computed: mapState({
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText
  }),
  components: {
    ReportHeader,
    ReportFooter,
    CheckInfoOneToOne,
    CheckResultOneToOne,
    SimilarListOneToOne,
    ExplainOneToOne,
    ComparativeLiteratureInfo
  },
  data() {
    return {
      checkResult: {}
    };
  },
  methods: {
    // 获取检测报告数据
    getData() {
      if (JSON.stringify(this.checkInfo) === '{}') {
        this.$store.dispatch('setCheckInfo');
      }
      if (!this.checkText) {
        this.$store.dispatch('setCheckText');
      }
    }
  },
  mounted() {
    this.getData();
  }
});
